import {convertTo} from "../../../services/odds-format";
import Config from "../config";

export default ({odds, format = null}) => {
    if (isNaN(odds) || parseFloat(odds) === 0) {
        return '-';
    }

    return convertTo(
        format!==null? format : (Config.betting['odds-format'] || 'decimal'),
        parseFloat(odds)
    );
}